import React, { FC, useEffect, useRef, useState } from "react";

interface AuthPageWrapperProps {
  children: any;
  title?: string;
  sub_title?: string;
}

const AuthPageWrapper: FC<AuthPageWrapperProps> = ({
  children,
  title,
  sub_title,
}) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const [isOverflowing, setIsOverflowing] = useState(false);

  useEffect(() => {
    if (containerRef.current) {
      const isContentOverflowing =
        containerRef.current.scrollHeight > containerRef.current.clientHeight;
      setIsOverflowing(isContentOverflowing);
    }
  }, [children]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="w-full min-h-screen flex flex-col lg:flex-row bg-white overflow-hidden">
        {/* Left Side */}
        <div className="hidden lg:flex lg:w-1/2 bg-primary text-white p-12 relative rounded-e-3xl flex-col gap-12">
          <img src="/assets/images/svg/logo.svg" alt="" className="w-[178px]" />
          <div className="flex flex-col gap-4">
            <h1 className="text-[36px] xl:text-[56px] font-bold mb-2 max-w-[90%]">
              Your Gateway to Seamless Trading
            </h1>
            <p className="text-base xl:text-lg max-w-[420px]">
              Manage connections, track transactions, and bridge the gap between
              buyers and sellers seamlessly.
            </p>
          </div>
          <img
            src="/assets/images/svg/auth_banner.svg"
            alt="Dashboard Preview"
            className="rounded-md absolute bottom-0 right-0 w-2/3 max-w-[400px]"
          />
        </div>

        {/* Right Side */}
        <div
          ref={containerRef}
          className={`w-full lg:w-1/2 p-4 sm:p-8 flex-1 h-screen overflow-y-auto flex flex-col items-center ${
            isOverflowing ? "justify-start" : "justify-center"
          }`}
        >
          <div className="flex flex-col w-full max-w-[450px] items-center lg:items-start">
            {/* Logo for small screens */}
            <img
              src="/assets/images/svg/logo.svg"
              alt="Logo"
              className="w-[178px] bg-primary rounded p-4 mb-4 lg:hidden"
            />
            {title && (
              <h2 className="text-2xl font-bold mb-2 text-center lg:text-left">
                {title}
              </h2>
            )}
            {sub_title && (
              <p className="text-sm text-gray-500 mb-6 text-center lg:text-left">
                {sub_title}
              </p>
            )}
          </div>
          <div className="w-full max-w-[450px]">{children}</div>
        </div>
      </div>
    </div>
  );
};

export default AuthPageWrapper;
